import React from 'react';

import Button from '@atlaskit/button';
import InlineMessage from '@atlaskit/inline-message';

import { FEATURE_FLAG } from '@qality/common-config';
import { StorageOfUniqueServices } from '@qality/common-service';

import { TextContainerStyled } from './CustomStatusesInfo.styled';

export default function CustomStatusesInfo(): JSX.Element {
  const hyperlinkDetails = FEATURE_FLAG.isPremium
    ? {
        buttonText: 'Learn more in our documentation',
        address:
          StorageOfUniqueServices.get('URLService').getStatusDocumentationUrl(),
      }
    : {
        buttonText: 'Try it free',
        address:
          StorageOfUniqueServices.get(
            'URLService'
          ).getQalityPlusMarketplaceUrl(),
      };

  const openStatusDocumentationPage = (): void => {
    window.open(hyperlinkDetails.address, '_blank');
  };

  return (
    <InlineMessage
      appearance='info'
      secondaryText='Customize Test Case Statuses'
    >
      <TextContainerStyled>
        <p>You can now add, rename or remove statuses used in QAlity Plus.</p>

        <Button
          appearance='link'
          onClick={openStatusDocumentationPage}
          spacing='none'
        >
          {hyperlinkDetails.buttonText}
        </Button>
      </TextContainerStyled>
    </InlineMessage>
  );
}
